import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, Typography, MenuItem, Select, Chip, InputLabel, FormControl, Checkbox, ListItemText, Autocomplete, Box, Paper, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import apiService from '../../service/apiService';
import { FormHelperText } from "@mui/material";

const AddCapacityBuild = () => {
  const [formData, setFormData] = useState({
    yearId: '',
    seasonId: '',
    capacityBuildingTypeId: '',
    capacityBuildingSubtypeId: "",
    mipIds: [],
    date: '',
    venue: '',
    topic: '',
    producerGroupIds: [],
    farmerIds: [],
    designation: '',
    resourcePerson: '',
    blockId: '',
    districtId: '',
    subType: "",
  });

  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [capacityBuildingTypes, setCapacityBuildingTypes] = useState([]);
  const [mips, setMips] = useState([]);
  const [producerGroups, setProducerGroups] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [capacityBuildingSubtypes, setCapacityBuildingSubtypes] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleProducerGroupChange = (event) => {
    const selectedProducerGroupIds = event.target.value.filter(id => id !== "");
    handleChange({
      target: {
        name: 'producerGroupIds',
        value: selectedProducerGroupIds
      }
    });
  };

  const handleFarmerChange = (event) => {
    const selectedFarmerIds = event.target.value.filter(id => id !== "");
    handleChange({
      target: {
        name: 'farmerIds',
        value: selectedFarmerIds
      }
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "mipIds" || name === "producerGroupIds" || name === "farmerIds" ? value : value,
      ...(name === "capacityBuildingTypeId" && { capacityBuildingSubtypeId: "" }),
    }));

    if (name === "capacityBuildingTypeId") {
      fetchSubtypes(value);
    }

    if (name === "producerGroupIds") {
      fetchFarmers(value);
    }
  };

  const fetchFarmers = (selectedProducerGroupIds) => {
    if (selectedProducerGroupIds.length === 0) {
      setFarmers([]);
      return;
    }

    apiService.post('/farmers/detail', {
      ProducerGroupId: selectedProducerGroupIds,
    })
      .then((response) => {
        setFarmers(response.data);
      })
      .catch((error) => {
        console.error('Error fetching farmer data:', error);
      });
  };

  const fetchBlocks = async (districtId) => {
    try {
      const response = await apiService.get(`/master/get-block-by-district/${districtId}`);
      if (response.data.status) {
        setBlocks(response.data.body.blocks);
      } else {
        setBlocks([]);
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      setBlocks([]);
    }
  };

  useEffect(() => {
    if (formData.blockId) {
      apiService
        .get(`/master/get-mip-by-block/${formData.blockId}`)
        .then((response) => {
          setMips(response.data.body || []);
          setFormData((prev) => ({ ...prev, mipIds: [] }));
        })
        .catch((error) => console.error("Error fetching MIPs:", error));
    }
  }, [formData.blockId]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.yearId) newErrors.yearId = "Year is required";
    if (!formData.seasonId) newErrors.seasonId = "Season is required";
    if (!formData.capacityBuildingTypeId) newErrors.capacityBuildingTypeId = "Capacity Building Type is required";
    if (!formData.mipIds || formData.mipIds.length === 0) newErrors.mipIds = "At least one MIP is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.venue) newErrors.venue = "Venue is required";
    if (!formData.topic) newErrors.topic = "Topic is required";
    if (!formData.producerGroupIds || formData.producerGroupIds.length === 0) newErrors.producerGroupIds = "At least one Producer Group is required";
    if (formData.farmerIds.length === 0) newErrors.farmerIds = "At least one Farmer is required";
    if (!formData.blockId) newErrors.blockId = "Block is required";
    if (!formData.districtId) newErrors.districtId = "District is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const isConfirmed = window.confirm("Are you sure you want to add this Capacity Building Info?");
    if (!isConfirmed) {
      return;
    }

    const payload = {
      yearId: formData.yearId,
      seasonId: formData.seasonId,
      capacityBuildingTypeId: formData.capacityBuildingTypeId,
      capacityBuildingSubtypeId: formData.capacityBuildingSubtypeId,
      mipIds: formData.mipIds,
      date: formData.date ? formData.date.split('-').reverse().join('-') : '',
      venue: formData.venue,
      topic: formData.topic,
      producerGroupIds: formData.producerGroupIds,
      farmerIds: formData.farmerIds,
      designation: formData.designation,
      resourcePerson: formData.resourcePerson,
      blockId: formData.blockId ? parseInt(formData.blockId, 10) : null,
      districtId: formData.districtId ? parseInt(formData.districtId, 10) : null,
    };

    apiService.post('/capacity-building', payload)
      .then((response) => {
        alert("Capacity Building Info added successfully!");
        navigate(-1);
      })
      .catch((error) => {
        console.error('Error submitting capacity building data:', error);
        alert('An error occurred while submitting the form. Please try again.');
      });
  };

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    apiService.get('/years/get-all')
      .then((response) => setYears(response.data))
      .catch((error) => console.error('Error fetching year data:', error));

    apiService.get('/seasons/get-all')
      .then((response) => setSeasons(response.data))
      .catch((error) => console.error('Error fetching season data:', error));

    apiService.get("districts/get-all")
      .then((response) => {
        setDistricts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });

    apiService.get('/producer-groups/get-all')
      .then((response) => setProducerGroups(response.data))
      .catch((error) => console.error('Error fetching producer groups:', error));
  }, []);

  useEffect(() => {
    apiService
      .get("/capacity-building-types/get-all")
      .then((response) => setCapacityBuildingTypes(response.data))
      .catch((error) =>
        console.error("Error fetching capacity building types:", error)
      );
  }, []);

  const fetchSubtypes = (typeId) => {
    if (!typeId) return;

    apiService
      .get(`/capacity-building/capacity-building-types/${typeId}/active-subtypes`)
      .then((response) => {
        setCapacityBuildingSubtypes(response.data.body || []);
      })
      .catch((error) =>
        console.error("Error fetching capacity building subtypes:", error)
      );
  };

  return (
    <div className="container-fluid p-4" style={{ maxHeight: "100vh", overflowX: "auto", backgroundColor: "#f8f9fa" }}>
      <div className="mx-3 mt-2 d-flex justify-content-between align-items-center">
        <Typography variant="h4" gutterBottom>
          Capacity Building Form
        </Typography>
        <p><span className='text-danger text-bold' style={{ fontSize: "18px" }}>*</span> mark fields are mandatory</p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Section 1: Year & Season */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Basic Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.yearId}>
                <InputLabel id="year-label">
                  Year <span style={{ color: "red" }}>*</span>
                </InputLabel>

                <Select
                  labelId="year-label"
                  id="year"
                  name="yearId"
                  value={formData.yearId || ""}
                  onChange={handleChange}
                  label="Year *"
                >
                  {years.map((year) => (
                    <MenuItem key={year.yearId} value={year.yearId}>
                      {year.yearValue}
                    </MenuItem>
                  ))}
                </Select>

                {errors.yearId && (
                  <FormHelperText>{errors.yearId}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.seasonId}>
                <InputLabel id="season-label">
                  Season <span style={{ color: "red" }}>*</span>
                </InputLabel>

                <Select
                  labelId="season-label"
                  id="season"
                  name="seasonId"
                  value={formData.seasonId || ""}
                  onChange={handleChange}
                  label="Season *"
                >
                  {seasons.map((season) => (
                    <MenuItem key={season.seasonId} value={season.seasonId}>
                      {season.seasonName}
                    </MenuItem>
                  ))}
                </Select>

                {errors.seasonId && (
                  <FormHelperText>{errors.seasonId}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        {/* Section 2: District, Block, MIP */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Location Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={districts}
                getOptionLabel={(option) => option.districtName || ""}
                value={districts.find((district) => district.districtId === formData.districtId) || null}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    districtId: newValue ? newValue.districtId : "",
                    blockId: "",
                  }));
                  if (newValue) fetchBlocks(newValue.districtId);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>District <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.districtId}
                    helperText={errors.districtId}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={blocks}
                getOptionLabel={(option) => option.blockName || ""}
                value={blocks.find((block) => block.blockId === formData.blockId) || null}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    blockId: newValue ? newValue.blockId : "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Block <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.blockId}
                    helperText={errors.blockId}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                options={mips}
                getOptionLabel={(option) => option.mipname || ""}
                multiple
                value={mips.filter((mip) => formData.mipIds.includes(mip.mipid))}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    mipIds: newValue.map((mip) => mip.mipid),
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>MIP <span style={{ color: "red" }}>*</span></>}
                    error={!!errors.mipIds}
                    helperText={errors.mipIds}
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 3: CB Type, CB Sub Type, Topic, Date, Venue */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Capacity Building Details
          </Typography>

          <Grid container spacing={3}>
            {/* CB TYPE */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth error={Boolean(errors.capacityBuildingTypeId)}>
                <InputLabel id="cb-type-label">
                  CB Type <span style={{ color: "red" }}>*</span>
                </InputLabel>

                <Select
                  labelId="cb-type-label"
                  id="capacityBuildingTypeId"
                  name="capacityBuildingTypeId"
                  value={formData.capacityBuildingTypeId || ""}
                  onChange={handleChange}
                  label="CB Type *"
                >
                  {capacityBuildingTypes.map((type) => (
                    <MenuItem
                      key={type.capacityBuildingTypeId}
                      value={type.capacityBuildingTypeId}
                    >
                      {type.typeName}
                    </MenuItem>
                  ))}
                </Select>

                {errors.capacityBuildingTypeId && (
                  <FormHelperText>{errors.capacityBuildingTypeId}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* CB SUB TYPE */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth error={Boolean(errors.capacityBuildingSubtypeId)}>
                <InputLabel id="cb-subtype-label">
                  CB Sub Type <span style={{ color: "red" }}>*</span>
                </InputLabel>

                <Select
                  labelId="cb-subtype-label"
                  id="capacityBuildingSubtypeId"
                  name="capacityBuildingSubtypeId"
                  value={formData.capacityBuildingSubtypeId || ""}
                  onChange={handleChange}
                  label="CB Sub Type *"
                  disabled={!capacityBuildingSubtypes.length}
                >
                  {capacityBuildingSubtypes.map((sub) => (
                    <MenuItem
                      key={sub.capacityBuildingSubtypeId}
                      value={sub.capacityBuildingSubtypeId}
                    >
                      {sub.subtypeName}
                    </MenuItem>
                  ))}
                </Select>

                {errors.capacityBuildingSubtypeId && (
                  <FormHelperText>{errors.capacityBuildingSubtypeId}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* DATE */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Date *"
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                error={!!errors.date}
                helperText={errors.date}
              />
            </Grid>

            {/* VENUE */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Venue *"
                name="venue"
                value={formData.venue}
                onChange={handleChange}
                error={!!errors.venue}
                helperText={errors.venue}
              />
            </Grid>

            {/* TOPIC (TEXT AREA BELOW) */}
            <Grid item xs={12} md={9}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Topic *"
                name="topic"
                value={formData.topic || ""}
                onChange={handleChange}
                error={Boolean(errors.topic)}
                helperText={errors.topic}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 4: PG, Farmers, Demographics */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Participants Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                multiple
                options={producerGroups}
                getOptionLabel={(option) => option.pgname || ""}
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option.pgname.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.producerGroupId}>
                    <Checkbox checked={selected} />
                    {option.pgname}
                  </li>
                )}
                value={
                  producerGroups
                    .filter(group => formData.producerGroupIds?.includes(group.producerGroupId)) || []
                }
                onChange={(event, newValue) => {
                  handleProducerGroupChange({
                    target: {
                      name: "producerGroupIds",
                      value: newValue.map((group) => group.producerGroupId),
                    },
                  });
                }}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip key={option.producerGroupId} label={option.pgname} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Producer Group <span style={{ color: "red" }}>*</span></>}
                    fullWidth
                    error={Boolean(errors.producerGroupIds)}
                    helperText={errors.producerGroupIds}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.producerGroupId === value.producerGroupId
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                multiple
                options={farmers}
                getOptionLabel={(option) => option.FarmerName}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox checked={selected} />
                    {option.FarmerName}
                  </li>
                )}
                value={farmers.filter(farmer => formData.farmerIds.includes(farmer.FarmerId))}
                onChange={(event, newValue) => {
                  handleFarmerChange({
                    target: {
                      name: "farmerIds",
                      value: newValue.map((farmer) => farmer.FarmerId),
                    },
                  });
                }}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip key={option.FarmerId} label={option.FarmerName} {...getTagProps({ index })} />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<>Farmer <span style={{ color: "red" }}>*</span></>}
                    fullWidth
                    error={Boolean(errors.farmerIds)}
                    helperText={errors.farmerIds}
                  />
                )}
              />
            </Grid>

          </Grid>
        </Paper>

        {/* Section 5: Resource Person Details */}
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom color="primary">
            Resource Person Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={<>Resource Person Name <span style={{ color: "red" }}>*</span></>}
                name="resourcePerson"
                value={formData.resourcePerson}
                onChange={handleChange}
                error={!!errors.resourcePerson}
                helperText={errors.resourcePerson}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={<>Designation <span style={{ color: "red" }}>*</span></>}
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                error={!!errors.designation}
                helperText={errors.designation}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Submit Buttons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default AddCapacityBuild;